import { render, staticRenderFns } from "./addImage.vue?vue&type=template&id=34125040&scoped=true"
import script from "./addImage.vue?vue&type=script&lang=js"
export * from "./addImage.vue?vue&type=script&lang=js"
import style0 from "./addImage.vue?vue&type=style&index=0&id=34125040&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34125040",
  null
  
)

export default component.exports